export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-960-9b0a08ba5dc70c35a9001d88b42356e0.webp";